(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function () {
    var el = document.querySelector('.footer__sunset');
    if (!el || !window.LjomenSol) return;
    var time = new Intl.DateTimeFormat(undefined, {
      hour: '2-digit',
      minute: '2-digit'
    }).format(new Date(window.LjomenSol.sunset));
    el.textContent = el.dataset.label + ' ' + time;
    el.hidden = false;
  })();

  } catch(e) { console.error(e); }
})();
})();
